// extracted by mini-css-extract-plugin
export default {"inputTextWithIcon":"InputDropdown_inputTextWithIcon__Lgb27"};